export default "__VITE_ASSET__0d5a8da6__"